module.exports = require('./helpers/bundle-url').getBundleURL('lxodM') + "leftpane.1421efa0.jpg";